// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","badge":"_1ZPrUAXCsE4pajt95hha6a"};